import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function Header({
  title,
  subtitle,
  bgColor = 'bg-primary',
  showBack = false,
  rightActions = null,
}) {
  const navigate = useNavigate();
  const { user }  = useAuth();

  return (
    <header className={`${bgColor} text-white px-4 py-3`}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          {showBack && (
            <button
              onClick={() => navigate(-1)}
              aria-label="Go back"
              className="text-white text-xl leading-none"
            >
              ←
            </button>
          )}
          <div className="min-w-0">
            <h1 className="font-bold text-base leading-tight truncate">{title}</h1>
            {subtitle && (
              <p className="text-xs opacity-70 mt-0.5 truncate">{subtitle}</p>
            )}
          </div>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          {rightActions}
        </div>
      </div>
    </header>
  );
}
